import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { find } from 'lodash';
import {
  AddDriverButtonsContainer,
  LinkStyleButton,
  QuestionsContainer,
  SubmitButton,
} from './styles';
import AdditionQuestionField from '../add-vehicle/additional-question-field';
import { submitPolicyChange } from '../../policyChangeAPI';
import { getAdditionalQuestions, getAllQuestionReplies } from './selector';
import PolicyChangePreview from '../policy-change-preview';
import { useNavigate } from 'react-router';
import {ga4Event} from "../../../../../utils/google-analytics-4";

export const ChangeLiabilityLimits = (props) => {
  const {
    dispatch,
    selectedPolicy,
    customerId,
    selectedPolicyChangeTemplate,
    policyChangePreview,
  } = props;

  const [additionalQuestions] = useState(getAdditionalQuestions(selectedPolicyChangeTemplate));
  const [answers, setAnswers] = useState({});

  useEffect(() => {
    ga4Event({category: 'change-coverage', action: 'change-liability-limits-start'});
    setInitialAnswers(additionalQuestions);
  }, []);

  const setAdditionalQuestionsAnswers = (index, answer, q) => {
    const theAnswer = {};
    theAnswer[index] = { answer, required: q.requiredInd };
    setAnswers((prevAnswers) => {
      return { ...prevAnswers, ...theAnswer };
    });
  };

  const setAdditionalSubQuestionsAnswers = (parentIndex, index, answer) => {
    const subQuestionAnswers = [];
    subQuestionAnswers[index] = answer;

    const theAnswer = [];
    theAnswer[parentIndex] = {
      answer: answers[parentIndex].answer,
      subQuestionAnswers,
    };
    setAnswers((prevAnswers) => {
      return { ...prevAnswers, ...theAnswer };
    });
  };

  const checkRequiredFields = () => {
    for (const [, value] of Object.entries(answers)) {
      if (!value.answer && value.required === 'Yes') return false;
    }
    return true;
  };

  const setInitialAnswers = (questions) => {
    let defaultAnswers = {};
    for (let i = 0; i < questions.length; i++) {
      if (questions[i].dataType === 'YesNo') {
        defaultAnswers[i] = { answer: 'No', required: questions[i].requiredInd };
      } else if (questions[i].dataType === 'Date') {
        defaultAnswers[i] = { answer: '', required: questions[i].requiredInd };
      } else {
        defaultAnswers[i] = { answer: '', required: questions[i].requiredInd };
      }
    }
    setAnswers(defaultAnswers);
  };

  const onSubmitButtonClick = async () => {
    let questionReplies = getAllQuestionReplies(additionalQuestions, answers);
    let payload = {
      changeDt: find(questionReplies, (o) => {
        return o.name === 'EffectiveDate';
      }).value,
      customerRef: customerId,
      templateIdRef: selectedPolicyChangeTemplate.id,
      policyDetail: {
        policyRef: selectedPolicy.value,
      },
      changeRequest: [
        {
          detailDescription: find(questionReplies, (o) => {
            return o.name === 'Reason';
          }).value,
        },
      ],
      questionReplies: [
        {
          questionReply: [
            find(questionReplies, (o) => {
              return o.name === 'Task.Note001';
            }),
            find(questionReplies, (o) => {
              return o.name === 'Task.Note002';
            }),
            find(questionReplies, (o) => {
              return o.name === 'Task.Note003';
            }),
            find(questionReplies, (o) => {
              return o.name === 'Task.Note004';
            }),
          ],
          id: 'QuestionReplies-001',
        },
      ],
      sourceCd: 'ServicePortal',
    };

    dispatch(submitPolicyChange(payload));
  };

  const navigate = useNavigate();

  return (
    <>
      {policyChangePreview ? (
        <PolicyChangePreview />
      ) : (
        <>
          <QuestionsContainer>
            {additionalQuestions.map((q, index) => {
              return (
                <AdditionQuestionField
                  id={q.name}
                  key={index}
                  q={q}
                  index={index}
                  setAdditionalQuestionsAnswers={setAdditionalQuestionsAnswers}
                  setAdditionalSubQuestionsAnswers={setAdditionalSubQuestionsAnswers}
                />
              );
            })}
          </QuestionsContainer>
          <AddDriverButtonsContainer>
            <LinkStyleButton
              onClick={() => {
                navigate('/dashboard');
              }}
            >
              Cancel
            </LinkStyleButton>
            <SubmitButton
              disabled={!checkRequiredFields()}
              onClick={() => {
                onSubmitButtonClick();
              }}
            >
              Submit
            </SubmitButton>
          </AddDriverButtonsContainer>
        </>
      )}
    </>
  );
};

ChangeLiabilityLimits.propTypes = {
  dispatch: PropTypes.func,
  selectedPolicy: PropTypes.object,
  customerId: PropTypes.string,
  selectedPolicyChangeTemplate: PropTypes.object,
  uploadFileSize: PropTypes.any,
  policyRefSelected: PropTypes.string,
  attachmentDescription: PropTypes.string,
  attachmentTemplateId: PropTypes.string,
  policyChangePreview: PropTypes.object,
  i18n: PropTypes.object,
};

const mapStateToProps = (state) => ({
  selectedPolicy: state.policyChangeSlice.selectedPolicy,
  selectedPolicyChangeTemplate: state.policyChangeSlice.selectedPolicyChangeTemplate,
  customerId: state.customerSlice.customer.systemId,
  uploadFileSize: state.configurationSlice.features.features.UploadFileSize,
  policyRefSelected: state.policyChangeSlice.selectedPolicy.policyRef,
  policyChangePreview: state.policyChangeSlice.policyChangePreview,
  i18n: state.i18nSlice.i18n,
});

export default connect(mapStateToProps)(ChangeLiabilityLimits);
